// يُضبط عن بُعد عبر postMessage من الـ main thread (زر محاكاة عدم الاتصال للاختبار)
let simulateOffline = false;

export function setSimulateOffline(value) {
	simulateOffline = Boolean(value);
}

function buildOfflineResponse(onFail) {
	return Promise.resolve(onFail()).then((offlineData) => {
		return new Response(
			JSON.stringify(offlineData),
			{
				headers: { 'service-worker': true }
			}
		);
	});
}

/**
 * @param {Request} request which is sent request
 * @param {Function} onSuccess has an response data as a param
 * @param {Function} onFail must return value to set response value
 */
export default function (request, onSuccess, onFail) {
	if (simulateOffline) {
		return buildOfflineResponse(onFail);
	}

	return new Promise((resolve) => {
		fetch(request)
			.then(response => {
				response.clone().json().then((data) => {
					onSuccess(data);
				})
				resolve(response);
			})
			.catch(async () => {
				resolve(await buildOfflineResponse(onFail));
			})
	})
}
